<rask-selector
    label="Sök transportföretag"
    [(ngModel)]="value"
    [debounceTime]="100"
    [viewFormatter]="viewFormatter"
    [formatter]="outputFormatter"
    [search]="search">
</rask-selector>